import request from '@/utils/request';

export function upload(data) {
    return request({
        url: '/common/upload/cos',
        method: 'post',
        data
    });
}

export function uploadBase64(data) {
    return request({
        url: '/common/uploadBase64',
        method: 'post',
        data
    });
}